import React, {useState, useEffect} from 'react'
import { httpss } from '../../utils/host';
import Notification from '../Noti/Notification';

export default function PopupReaction({ selectedUser, onClose, refresh }) {
    console.log("selectedUser", selectedUser)
    const IconRenger = [
    { name: 'like', icon: 'like 👍' },
    { name: 'love', icon: 'love ❤️' },
    { name: 'haha', icon: 'haha 😂' },
    { name: 'care', icon: 'care 😊' },
    { name: 'wow', icon: 'wow 😲' },
    { name: 'sad', icon: 'sad 😢' },
    { name: 'angry', icon: 'angry 😡' },
    ]
  const closePopup = (id) => {
    if (id === 'formPopup'){
      onClose();
    } else {
      onClose();
    }
  };
  const [notification, setNotification] = useState(null);
  const [email, setEmail] = useState('');

  const PostConnect = async () => {
    const response = await fetch(`${httpss}/apis_v1/user/connect_user365`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, UserId: selectedUser.UserId, name: selectedUser.name }),
    });

    if (response.ok) {
      const data = await response.json();
      // alert (data.msg)
      setNotification(data.msg);
      refresh();
      // onClose();
    } else {
      alert('Failed to send email.');
    }
  }

  const getFormattedTime = (list) => {
    const lastItem = list?.[list.length - 1];
    if (lastItem.created_time || lastItem.createdAt) {
      return new Date(lastItem.created_time || lastItem.createdAt).toLocaleString('vi-VN');
    }
    return null;
  };

  return (
    <div id='formPopup' className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-start pt-20 z-50" onClick={(e) => closePopup(e.target.id)}>
      <div className="bg-white rounded-xl shadow-2xl max-w-4xl w-full p-6 relative mx-2 slide-down border border-blue-200" onClick={(e) => e.stopPropagation()}>
      {notification && (
        <Notification message={notification} onClose={() => setNotification(null)} />
      )}
        {/* Header */}
        <div className="mb-4 flex justify-between items-center flex-wrap gap-2">
          <div>
            <span className="text-xl font-semibold text-blue-600">FB: {selectedUser.name}</span>
            {selectedUser.user365 && (
              <p className="text-sm text-green-600 mt-1">✅ {selectedUser.user365}</p>
            )}
          </div>

          <form
            onSubmit={(e) => {
              e.preventDefault();
              PostConnect();
            }}
            className="flex items-center space-x-2"
          >
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Nhập email"
              className="border rounded px-3 py-1 text-sm"
            />
            <button
              type="submit"
              disabled={!email.includes('@') || email.length === 0}
              className={`text-sm px-4 py-1 rounded text-white 
                ${email.includes('@') && email.length > 0
                  ? 'bg-blue-500 hover:bg-blue-600'
                  : 'bg-gray-300 cursor-not-allowed'
                }`}
            >
              Cập nhật
            </button>
          </form>

        </div>

        {/* Table */}
        {selectedUser.interactedPosts?.length === 0 ? (
          <p className="text-gray-500 italic">Không có bài viết nào được tương tác.</p>
        ) : (
          <div className="overflow-x-auto max-h-[420px] overflow-y-auto">
            <table className="w-full table-auto border-collapse text-sm text-left">
              <thead className="bg-blue-100 sticky top-0 z-10">
                <tr>
                  <th className="border px-3 py-2 w-[35%]">Nội dung</th>
                  <th className="border px-3 py-2">Bình luận</th>
                  <th className="border px-3 py-2">Cảm xúc</th>
                  <th className="border px-3 py-2">Thời gian</th>
                  <th className="border px-3 py-2">Link</th>
                </tr>
              </thead>
              <tbody>
                {selectedUser.interactedPosts.map((post) => (
                  <tr key={post.id} className="hover:bg-gray-50">
                    <td className="border px-3 py-2">
                      {post.message
                        ? post.message.length > 100
                          ? `${post.message.slice(0, 100)}...`
                          : post.message
                        : <i className="text-gray-400">(Không có nội dung)</i>}
                    </td>
                    <td className="border px-3 py-2">
                      {post.userComment ? (
                        <span>“{post.userComment}”</span>
                      ) : (
                        <span className="text-gray-400">—</span>
                      )}
                    </td>
                    <td className="border px-3 py-2 text-center">
                      {IconRenger.find((item) => item.name === post.reactionType)?.icon ?? '—'}
                    </td>
                    <td className="border px-3 py-2">
                      {getFormattedTime(post.ReactionFBs) || getFormattedTime(post.CommentFBs) || (
                        <span className="text-gray-400">—</span>
                      )}
                    </td>

                    <td className="border px-3 py-2">
                      <a
                        href={post.permalink_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-500 hover:underline"
                      >
                        Xem bài viết
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* Close button */}
        <button
          onClick={closePopup}
          className="absolute top-2 right-2 text-gray-500 hover:text-red-600 text-xl"
        >
          ×
        </button>
      </div>
    </div>
  )
}
